var escape = require("../../../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fgf-cla[data-v-6d06f217]{position:absolute;right:30%;height:40%;top:40%;width:.083333rem;background-image:url(" + escape(require("@/assets/new/dashboard/fgx.png")) + ");background-size:100% 100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6d06f217","scoped":true,"hasInlineConfig":false}!./node_modules/px2rem-loader?{"remUnit":12}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/modules/tenantManager/dashboard/onlineDeviceChat/onlineDeviceChat.vue
// module id = fSo/
// module chunks = 8